import { render } from "./FacetsSidebar.vue?vue&type=template&id=2eb06e4a&scoped=true"
import script from "./FacetsSidebar.vue?vue&type=script&lang=js"
export * from "./FacetsSidebar.vue?vue&type=script&lang=js"

import "./FacetsSidebar.vue?vue&type=style&index=0&id=2eb06e4a&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2eb06e4a"]])

export default __exports__